// extracted by mini-css-extract-plugin
export default {"infoContainer":"LessonPage_infoContainer__SJOK9","contentContainer":"LessonPage_contentContainer__RhFza","formTitle":"LessonPage_formTitle__4FMUD"};